<template>
  <div class="info_window">
    <div v-if="placements" class="info_window_wrapper">
      <div class="thumbnail_section">
        <div v-for="(data, index) in placements.placement" :key="index" >
          <a :href="loadBillboardImgUrl(data.photo)" target="_blank">
            <img class="bg_img photo" :src="loadBillboardImg(data.photo)" alt >
          </a>
        </div>
        <a v-if="showSlider()" class="prev icon-chevronleft" onclick="prev()"></a>
        <a v-if="showSlider()" class="next icon-chevronright" onclick='next()'></a>
        <template v-if="showSlider()">
          <div v-for="(data, index) in placements.placement" :key="'A' + index" class="index_number" >
            <div class="numberText">{{Math.abs(index - placements.placement.length)}} / {{placements.placement.length}}</div>
          </div>
        </template>
      </div>
      <div class="info_section">
        <div v-for="(data, index) in placements.placement" :key="'B' + index" >
          <div class="code" ref="billboard">
            Billboard, {{data.side ? placements.code + data.side : placements.code}}
          </div>
          <input type="hidden" ref="code" v-bind:value="placements.code">
        </div>
        <div class="separator"></div>
        <div class="address">
          <div class="address__title">Detail Address </div>
          <div class="address__content">{{placements.address ? placements.address : '-'}}</div>
        </div>
        <div v-for="(data, index) in placements.placement" :key="'C' + index" >
          <div class="directions">
            <div class="directions__title">Direction View </div>
            <div class="directions__content" ref="direction">{{data.direction ? data.direction : '-'}}</div>
          </div>
        </div>
        <div class="separator"></div>
        <div class="traffic">
          <span class="traffic__title">Est. Traffic (Day)</span>
          <span class="traffic__content">{{placements.traffic ? formatNumber(placements.traffic) : '-'}}</span>
        </div>
        <div v-for="(data, index) in placements.placement" :key="'D' + index" >
          <div class="recommendations">
            <div class="recommendations__status">
              <span class="recommendations__status__title">Top Recommendation </span>
              <span class="recommendations__status__content">{{data.top_recommendation ? data.top_recommendation : '-'}}</span>
            </div>
            <div class="recommendations__reason">
              <div class="recommendations__reason__title">Reason </div>
              <div class="recommendations__reason__content">{{data.reason ? data.reason : '-'}}</div>
            </div>
          </div>
        </div>
        <div class="separator"></div>
        <div class="size_dimension">SIZE & DIMENSION</div>
        <div class="row_data">
          <span class="left">Width </span>
          <span class="right">{{placements.width ? placements.width + ' Meters' : '-'}}</span>
        </div>
        <div class="row_data">
          <span class="left">Height </span>
          <span class="right">{{placements.height ? placements.height + ' Meters' : '-'}}</span>
        </div>
        <div class="row_data">
          <span class="left">Orientation </span>
          <span class="right">{{placements.orientation ? placements.orientation : '-'}}</span>
        </div>
        <div class="row_data">
          <span class="left">Lighting </span>
          <span class="right">{{placements.lighting ? placements.lighting : '-'}}</span>
        </div>
        <div class="separator"></div>
        <div class="price_section">PRICE</div>
        <div class="price_notes">
          <span class="color-sunrise">*Price after discount before PPN</span>
        </div>
        <div v-for="(data, index) in placements.placement" :key="'E' + index" >
          <div class="price">
            <div class="row_data">
              <span class="left">1 Month </span>
              <span class="right color-pink">{{data.price_1 ? formatNumber(data.price_1) + ' IDR' : '-'}}</span>
            </div>
            <div class="row_data">
              <span class="left">3 Month </span>
              <span class="right color-pink">{{data.price_3 ? formatNumber(data.price_3) + ' IDR' : '-'}}</span>
            </div>
            <div class="row_data">
              <span class="left">6 Month </span>
              <span class="right color-pink">{{data.price_6 ? formatNumber(data.price_6) + ' IDR' : '-'}}</span>
            </div>
            <div class="row_data">
              <span class="left">12 Month </span>
              <span class="right color-pink">{{data.price_12 ? formatNumber(data.price_12) + ' IDR' : '-'}}</span>
            </div>
            <div class="row_data">
              <span class="left">Per m2 </span>
              <span class="right color-pink">{{data.price_per_m2 ? formatNumber(data.price_per_m2) + ' IDR' : '-'}}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-for="(data, index) in placements.placement" :key="'F' + index">
          <div class="button-section">
            <div class="button-section__remove" v-if="added(data.id)">
              <button 
                class="btn-small secondary"
                :idPlacement="data.id" 
                onclick="removeFromOrder(this)"
              >Remove from Campaign</button>
            </div>
            <div class="button-section__add" v-else>
              <button 
                class="btn-small primary" 
                type="button" 
                :idPlacement="data.id"
                :codeLocation="placements.code"
                :cityId="placements.city"
                :cityName="placements.city_name" 
                :direction="data.direction"
                :side="data.side"
                ref="buttonCampaign"
                onclick="addToItems(this)"
              >Add to Campaign </button>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { viewPrice } from '@/lib/config'
export default {
  name: 'info-window',
  props: {
    placements: { type : Object },
    listOrder: { type: Array }
  },
  data(){
    return{
      slideIndex : [],
      view : viewPrice
    }
  },
  beforeMount() {},
  beforeUpdate() {},
  updated() {
    this.$emit('updateData')
    this.slideIndex = [
      this.placements.placement.length - 1, 
      this.placements.placement.length - 1, 
      this.placements.placement.length - 1, 
      this.placements.placement.length - 1, 
      this.placements.placement.length - 1, 
      this.placements.placement.length - 1,
      this.placements.placement.length - 1,
      this.placements.placement.length - 1
    ];
  },
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    removeFromOrder(item) {
      let idPlacement = parseInt(item.getAttribute('idPlacement'));
      let deletedItem = { "id": idPlacement };
      this.$emit('removeFromOrder', deletedItem);
    },
    added(id) {
      return this.listOrder.some(item => item.id === parseInt(id));
    },
    addToItems(item) {
      let idPlacement = item.getAttribute('idPlacement');
      let codeLocation = item.getAttribute('codeLocation');
      let cityId = item.getAttribute('cityId');
      let cityName = item.getAttribute('cityName');
      let direction = item.getAttribute('direction');
      let side = item.getAttribute('side');

      let newItem = { 
        "id": parseInt(idPlacement),
        "location": {
          "code": codeLocation,
          "city": {
            "id": parseInt(cityId),
            "name": cityName
          },
        },
        "direction": direction,
        "side": side
      };
      
      this.$emit('addToItems', newItem);
    },
    next() {
      this.showSlides(this.slideIndex[0] - 1, "directions", "block", 0);
      if(this.view == 'true'){
        this.showSlides(this.slideIndex[1] - 1, "price", "block", 1);
      }
      this.showSlides(this.slideIndex[2] - 1, "photo", "flex", 2);
      this.showSlides(this.slideIndex[3] - 1, "recommendations", "block", 3);
      this.showSlides(this.slideIndex[4] - 1, "numberText", "block", 4);
      this.showSlides(this.slideIndex[5] - 1, "side", "flex", 5);
      this.showSlides(this.slideIndex[6] - 1, "code", "flex", 6);
      this.showSlides(this.slideIndex[7] - 1, "button-section", "flex", 7);
    },
    prev() {
      this.showSlides(this.slideIndex[0] + 1, "directions", "block", 0);
      if(this.view == 'true'){
        this.showSlides(this.slideIndex[1] + 1, "price", "block", 1); 
      }
      this.showSlides(this.slideIndex[2] + 1, "photo", "flex", 2);
      this.showSlides(this.slideIndex[3] + 1, "recommendations", "block", 3);
      this.showSlides(this.slideIndex[4] + 1, "numberText", "block", 4);
      this.showSlides(this.slideIndex[5] + 1, "side", "flex", 5);
      this.showSlides(this.slideIndex[6] + 1, "code", "flex", 6);
      this.showSlides(this.slideIndex[7] + 1, "button-section", "flex", 7);
    },
    showSlides(n, div, style, num){
      var i;
      var slides = document.getElementsByClassName(div);
      if (n > (slides.length/2 - 1)) {n = 0}    
      if (n < 0) {n = (slides.length/2 - 1)}
      for (i = 0; i < slides.length; i++) {
          slides[i].style.display = "none";  
      }
      
      if (slides.length) {
        slides[n].style.display = style;
      }
      
      this.slideIndex[num] = n
    },
    loadBillboardImg(photo) {
      if (photo) {
        if (photo.thumbnail_320) {
          return photo.thumbnail_320
        }
      }else{
        return '/img/notfound/img-placeholder-landscape@2x.png'
      }
    },
    loadBillboardImgUrl(photo) {
      if (photo) {
        return photo.image
      }

      return '#'
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
    },
    showSlider() {
      return this.placements.placement.length > 1
    }
  },
  created() {
    const vm = this
    window.next = function() {
      vm.next()
    }
    window.prev = function() {
      vm.prev()
    }
    window.addToItems = function(index) {
      vm.addToItems(index)
    }
    window.added = function(id) {
      vm.added(id)
    }
    window.removeFromOrder = function(item) {
      vm.removeFromOrder(item)
    }
  }
}
</script>

<style lang="scss" scoped>
  .index_number {
    position: absolute;
    bottom: 35px;
  }

  .code {
    font-size: 13px;
    width: 200px;
    height: 18px;
    font-weight: bold;
    line-height: 1.38;
    letter-spacing: -0.1px;
  }

  .address, .directions, .recommendations__reason {
    margin-bottom: 10px;

    &__title {
      width: 100px;
      font-size: 13px;
      line-height: 1.38;
      letter-spacing: -0.1px;
      color: #878787;
    }

    &__content {
      width: 200px;
      font-size: 13px;
      line-height: 1.38;
      letter-spacing: -0.1px;
    }
  }

  .traffic, .recommendations__status {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;

    &__title {
      font-size: 13px;
      line-height: 1.38;
      letter-spacing: -0.1px;
      color: #878787;
    }

    &__content {
      font-size: 13px;
      line-height: 1.38;
      letter-spacing: -0.1px;    
    }
  }

  .size_dimension {
    font-size: 11px;
    line-height: 1.4;
    letter-spacing: 0.3px;
    margin-bottom: 10px;
  }

  .price_section {
    font-size: 11px;
    line-height: 1.4;
    letter-spacing: 0.3px;
  }

  .price_notes {
    margin-bottom: 10px;
  }

  .color-sunrise {
    font-size: 11px;
  }

  .button-section {
    display: flex;
    justify-content: space-evenly;
    padding-top: 15px;
    padding-bottom: 15px;

    .primary {
      font-size: 14px;
      height: 32px;
      padding: 5px 55px 5px 55px;
    }
    
    .secondary {
      font-weight: bold;
      font-size: 14px;
      height: 32px;
      padding: 5px 31px 5px 31px;
      border: solid 1px #878787;
    }
  }
</style>
